// src/settings/SettingsTabMenu.jsx
import React from 'react';
import styles from './Settings.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { redirectToLogin } from '../utils/authRedirect';

const apiUrl = process.env.REACT_APP_API_URL;

const TABS = [
  { key: 'profil', label: 'Editare profil' },
  { key: 'preferinte', label: 'Preferinte' },
];

const SettingsTabMenu = ({ activeTab, onTabClick }) => {
  const handleLogout = async () => {
    try {
      await fetch(`${apiUrl}/logout`, { method: 'POST', credentials: 'include' });
      redirectToLogin();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };
  return (
    <>
      <div className={styles.tabMenuCard}>
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={activeTab === tab.key ? styles.tabActive : styles.tab}
            onClick={() => onTabClick(tab.key)}
            style={{ width: '95%' }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {/* Buton logout sub card */}
      <div style={{ marginTop: 32, display: 'flex', justifyContent: 'center' }}>
        <button
          className={styles.mobileMenuRowCard + ' ' + styles.mobileMenuRowInner}
          style={{ maxWidth: '100%', width: '100%', display: 'flex', alignItems: 'center', gap: 12, fontSize: '1.1rem', border: '2px solid #abababbb', borderRadius: 14, background: '#fff', cursor: 'pointer' }}
          onClick={handleLogout}
        >
          <FontAwesomeIcon icon={faRightFromBracket} style={{ fontSize: '1.3em' }} />
          Deconectare
        </button>
      </div>
    </>
  );
};

export default SettingsTabMenu;
